import { Injectable } from '@angular/core';
import { GeneralDialogComponent } from '@app/components/dialog/general-dialog.component';
import { BrnDialogRef } from '@spartan-ng/brain/dialog';
import { HlmDialogService } from '@spartan-ng/helm/dialog';

@Injectable({
    providedIn: 'root',
})
export class ErrorDialogService {
    constructor(private dialog: HlmDialogService) {}

    public openErrorDialog(message: string): BrnDialogRef {
        const dialogRef = this.dialog.open(GeneralDialogComponent, {
            context: {
                title: 'Something went wrong',
                message,
            },
        });
        return dialogRef;
    }
}
